'use strict';

/**
 * List item for the matching dialog
 *
 * @category   View
 * @module     import
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/match-list-item.hbs');

var MatchListItemView = ColidoItemView.extend({
    template: template,

    wrapItem: false,

    viewData: {},

    ui: {
        component: '.box',
        selectTargetField: 'select[name="target-field"]',
        dismissButton: '[data-action="dismiss"]',
        includeButton: '[data-action="include"]',
    },

    events: {
        'change @ui.selectTargetField': 'onTargetFieldChange',
        'click @ui.dismissButton': 'onActionDismiss',
        'click @ui.includeButton': 'onActionInclude',
    },

    modelEvents: {
        'change:fieldname': 'fieldnameChanged',
        'change:dismissed': 'dismissedChanged',
        'invalid': 'modelInvalid',
    },

    //@todo
    // initialize: function(options) {
    //     ColidoItemView.prototype.initialize.apply(this, arguments);
    //     this.listenTo(this.getOption('fieldsCollection'), 'change', this.globalTargetSelectionChanged);
    // },

    /**
     * Is triggered when the dismissed button is clicked
     * @param {object} event The click event
     */
    onActionDismiss: function(event) {
        this.model.set('dismissed', true);
    },

    /**
     * Is triggered when the include button is clicked
     * @param {object} event The click event
     */
    onActionInclude: function(event) {
        this.model.set('dismissed', false);
    },

    /**
     * Is triggered from model, when the selected field has been changed
     * @param {ImportModule.MatchModel} model The match model
     */
    fieldnameChanged: function(model, newVal) {
        // Set proper class
        this.ui.component.toggleClass('box-import-match-active', model.hasColumnSelected());
        this.ui.component.removeClass('box-import-match-error');

        // Trigger selection
        var previous = model.changed.fieldname && model._previousAttributes.fieldname
            ? model._previousAttributes.fieldname
            : null;

        // App.radio('base').trigger(
        //     'collection-fields:selection-changed',
        //     model.get('fieldname'),
        //     previous,
        //     !model.get('dismissed')
        // );

        this.trigger('fieldmapping:change');

        // this.jumpToNext();
    },

    /**
     * Is triggered from model, when dismissed has been changed
     * @param {ImportModule.MatchModel} model          The match model
     * @param {boolean}                 dismissedState The enw value for dismissed
     */
    dismissedChanged: function(model, dismissedState) {
        // Set proper class
        this.ui.component.toggleClass('box-import-match-dismissed', model.get('dismissed'));
        this.ui.component.toggleClass('box-import-match-active', model.hasColumnSelected());
        this.ui.component.removeClass('box-import-match-error');

        // Activate deactivate select field
        this.ui.selectTargetField.prop('disabled', model.get('dismissed'));

        if (dismissedState) {
            var fieldName = this.model.get('fieldname');
            this.model.set('fieldname', null);
            // App.radio('base').trigger(
            //     'collection-fields:selection-changed',
            //     fieldName,
            //     null,
            //     !model.get('dismissed')
            // );
        }

        this.trigger('fieldmapping:change');

        if (model.get('dismissed')) {
            // this.jumpToNext();
        }
    },

    /**
     * Is triggered from model when validation fails
     * @param {ImportModule.MatchModel} model The match model
     * @param {String} error The error message
     */
    modelInvalid: function (model, error, options) {
        if (this.getOption('importModel') && this.getOption('importModel').isValidationEnabled()) {
            this.ui.component.addClass('box-import-match-error');
            this.ui.component.removeClass('box-import-match-dismissed box-import-match-active');
        }
    },

    onRender: function() {
        ColidoItemView.prototype.onRender.apply(this, arguments);

        this._renderFieldSelect();
    },

    /**
     * Is triggered by selectfield, when something else was selected
     * @param event
     */
    onTargetFieldChange: function(event) {
        var val = $(event.currentTarget).val();
        if (val && val.length) {
            // Update model
            this.model.set({
                fieldname: val,
                dismissed: false,
            });
        } else {
            this.model.set({
                dismissed: true,
            });
        }

        this.triggerMethod('component:match:field:changed', val);
    },

    onUpdateMappingSelectboxes: function() {
        this._renderFieldSelect();
    },

    /**
     * Scrolls to the next box
     */
    jumpToNext: function() {
        // Jump to next field
        var next = this.ui.component.next();
        if (next.length > 0) {
            next.find('select').focus();
            var scrollLeft = this.$el.parents('.import-match-list-wrapper').scrollLeft();
            this.$el.parents('.import-match-list-wrapper').animate({
                scrollLeft: scrollLeft + this.ui.component.outerWidth() + parseInt(this.ui.component.css('marginRight')),
            }, 400);
        }
    },

    /**
     * Is triggered, when sowhere the importField selection has changed
     */
    globalTargetSelectionChanged: function() {
        this._renderFieldSelect();
    },

    /**
     * Renders the select field
     * @private
     */
    _renderFieldSelect: function() {
        var importFields = _.clone(this.getOption('fieldsCollection'));

        importFields.push({
            fieldName: '',
            name: App.t('settings::import:no-field-selected'),
            isMultipleImport: true,
        })

        this.renderSelectOptions(
            this.ui.selectTargetField,
            importFields,
            'fieldName',
            'name',
            function(item, model) {
                return item.value === this.model.get('fieldname');
            }.bind(this),
            function(item, model) {
                //never disable multi import fields
                if (model.isMultipleImport) {
                    return false;
                }

                //never disable matched fields
                if (model.fieldName === this.model.get('fieldname')) {
                    return false;
                }

                //fieldname is already matched somewhere else so disable it
                return this.model.collection.findWhere({fieldname: model.fieldName});
            }.bind(this),
            App.t('settings::import:please-select-field')
            // 'groupName'
        );
    },
});

module.exports = MatchListItemView;